module.exports = __webpack_public_path__ + "static/img/1apptransfer.fa71052b.png";